﻿$.fn.dxCtrlDisplayImgSimple = function custom_dxCtrlDisplayImgSimple(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrldisplayimgsimple dx-ctrl");
        this.createInstance(new cdxCtrlDisplayImgSimple(this, option));
    }
    return this;
}

window.cdxCtrlDisplayImgSimple = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var img = null
    function mConstruit() {
        container.empty()
        container.css({
            position: "absolute",
            width: "100vw",
            height: "100vh",
            "z-index": mGetMaxZindex(),
            "background-color":"rgba(0,0,0,0.8)"
        })

        // 👉 container principal
        var viewer = $("<div>").css({
            position: "relative",
            width: "100vw",
            height: "100vh"
        }).appendTo(container);

        dxBtClose = $("<div style='position:absolute;z-index:6;top:2px;right:5px'/>").appendTo(viewer).dxCtrlButton({
            icon: 'fas fa-times',
            width: HeightButton,
            height: HeightButton,
            onClick: function (e) { container.mRemove() }
        }).dxCtrlButton("instance");

        // 👉 image
        img = $("<img style='margin:10%;'>").css({
            width: "calc(100% - 10%)",
            height: "calc(100% - 10%)",
            objectFit: "cover",
            margin:"5%"
        }).appendTo(viewer);

        // 👉 flèche gauche
        var left = $("<div>").html("❮").css({
            position: "absolute",
            top: "50%",
            left: "10px",
            transform: "translateY(-50%)",
            fontSize: "50px",
            color: "white",
            background: "rgba(0,0,0,0.3)",
            padding: "10px 20px",
            cursor: "pointer",
            userSelect: "none"
        }).appendTo(viewer);

        // 👉 flèche droite
        var right = $("<div>").html("❯").css({
            position: "absolute",
            top: "50%",
            right: "10px",
            transform: "translateY(-50%)",
            fontSize: "50px",
            color: "white",
            background: "rgba(0,0,0,0.3)",
            padding: "10px 20px",
            cursor: "pointer",
            userSelect: "none"
        }).appendTo(viewer);

        // 👉 events
        right.on("click", next);
        left.on("click", prev);

        $(document).off("keydown.img")
        $(document).on("keydown.img", function (e) {
            if (e.key === "ArrowRight") next();
            if (e.key === "ArrowLeft") prev();
        });

        show()
    }

    function show() {
        img.fadeOut(200, function () {
            img.attr("src", option.dataSource[option.index].url + "?d=" + (new Date()).getTime()).fadeIn(200);
        });
    }

    function next() {
        option.index = (option.index + 1) % option.dataSource.length;
        show();
    }

    function prev() {
        option.index = (option.index - 1 + option.dataSource.length) % option.dataSource.length;
        show();
    }


    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}